import { editPatientAllergyByUserId } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type { EditPatientAllergyRequestT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchEditPatientAllergyByUserId(
  userId: string,
  allergyId: string,
  data: EditPatientAllergyRequestT,
  signal?: AbortSignal
): Promise<unknown> {
  const config = await createLotusRequestConfig({ signal });
  const response = await editPatientAllergyByUserId(userId, allergyId, data, config);
  return lotusHealthZod.editPatientAllergyByUserIdResponse.parse(response.data);
}
